import {
  BadgeCheck,
  Timer,
  Smartphone,
  MessagesSquare,
  ShieldCheck,
  TrendingUp,
} from "lucide-react";
import Reveal from "./Reveal";
import { useT } from "../../i18n/I18nContext";

const ICONS = [BadgeCheck, Timer, Smartphone, MessagesSquare, ShieldCheck, TrendingUp];

export const WhyChooseUs = () => {
  const t = useT();
  return (
    <section
      id="why-us"
      data-testid="why-section"
      className="py-24 lg:py-32 bg-[#0A2342] relative overflow-hidden"
    >
      <div
        className="absolute inset-0 opacity-[0.06] pointer-events-none"
        style={{
          backgroundImage:
            "linear-gradient(to right, #ffffff 1px, transparent 1px), linear-gradient(to bottom, #ffffff 1px, transparent 1px)",
          backgroundSize: "56px 56px",
        }}
        aria-hidden="true"
      />

      <div className="relative max-w-7xl mx-auto px-6 lg:px-8">
        <div className="max-w-3xl">
          <Reveal>
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#10B981]">
              {t.why.eyebrow}
            </p>
          </Reveal>
          <Reveal delay={60}>
            <h2 className="mt-4 text-3xl sm:text-4xl lg:text-5xl font-bold text-white tracking-tight leading-[1.1]">
              {t.why.title}
            </h2>
          </Reveal>
          <Reveal delay={120}>
            <p className="mt-5 text-base lg:text-lg text-slate-300 leading-relaxed">
              {t.why.body}
            </p>
          </Reveal>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {t.why.items.map((r, i) => {
            const Icon = ICONS[i] || BadgeCheck;
            return (
              <Reveal key={r.title} delay={60 * i}>
                <div
                  data-testid={`why-card-${i}`}
                  className="h-full rounded-2xl p-7 bg-white/[0.04] border border-white/10 hover:bg-white/[0.07] hover:border-white/20 transition-all duration-300"
                >
                  <span className="inline-flex w-11 h-11 items-center justify-center rounded-xl bg-[#10B981]/15 text-[#10B981]">
                    <Icon className="w-5 h-5" />
                  </span>
                  <h3 className="mt-5 text-lg font-bold text-white leading-snug">
                    {r.title}
                  </h3>
                  <p className="mt-2 text-sm text-slate-300 leading-relaxed">
                    {r.desc}
                  </p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
